import { portfolio } from '~api';
import { getField, updateField } from 'vuex-map-fields';
import { Handler } from '~services';
import i18n from '../i18n';

const LOADING = 'LOADING';
// eslint-disable-next-line no-unused-vars
const SET_REFRESH_TIME = 'SET_REFRESH_TIME';

const state = {
    data: [],
    refreshTime: 0,
    isLoading: false,
};

const actions = {
    /**
     * Get refresh time
     * @param commit
     * @returns {Promise<void>}
     */
    async getRefreshTime({ commit }) {
        const resp = await portfolio.getRefreshTime();

        if (resp.ok) {
            commit(SET_REFRESH_TIME, resp.data);
        } else {
            Handler.handleResponse(resp);
        }
    },
    /**
     * Set refresh time
     * @param commit
     * @returns {Promise<void>}
     */
    async setRefreshTime({ commit }, val) {
        let errorMessage = i18n.t('portfolio.setRefreshTimeErrorMessage');
        let successMessage = i18n.t('portfolio.setRefreshTimeSuccessMessage');

        const resp = await portfolio.setRefreshTime(parseInt(val));

        commit(SET_REFRESH_TIME, val);

        Handler.handleResponse(resp, successMessage, errorMessage);
    },
};

const mutations = {
    // Add the `updateField` mutation to the
    // `mutations` of your Vuex store instance.
    updateField,
    [LOADING](state) {
        state.isLoading = !state.isLoading;
    },
    [SET_REFRESH_TIME](state, val) {
        state.refreshTime = val;
    },
};

const getters = {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField,
    refreshTime: (state) => state.refreshTime,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
